module.exports = __webpack_public_path__ + "assets/share_parents.eb3195d5.svg";